import { render } from "./SearchInput.vue?vue&type=template&id=04dfc8ea&scoped=true"
import script from "./SearchInput.vue?vue&type=script&lang=js"
export * from "./SearchInput.vue?vue&type=script&lang=js"

import "./SearchInput.vue?vue&type=style&index=0&id=04dfc8ea&scoped=true&lang=css"

import exportComponent from "/var/www/abg/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04dfc8ea"]])

export default __exports__